import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../shared/atoms/Box';
import ButtonsWithPop from './ButtonsWithPop';
import Text from '../../shared/atoms/Text';

const TakeCare = () => {
  const { t } = useTranslation();
  return (
    <Box position="relative" minHeight={{ xs: 'auto', md: 640 }} zIndex={0}>
      <Box zIndex={2}>
        <ButtonsWithPop mt={6} />
        <Box alignSelf="center" maxWidth={{ xs: '80%', md: '30%' }}>
          <Text
            textAlign="center"
            color="black"
            fontSize={{ xs: 'md', md: 'xxl' }}
            fontWeight={2}
            mt={6}
            px={4}
            lineHeight="copy">
            {t('takecare.text')}
          </Text>
        </Box>
      </Box>
      <Box display={{ xs: 'none', md: 'block' }}>
        <Box>
          <img
            src="/static/img/pictos/giftcard/hero-image-rj-landing-giftcard.png"
            alt="Carte cadeau réparation vélo Roulez Jeunesse"
            style={{
              position: 'absolute',
              zIndex: 1,
              minWidth: 1200,
              left: '50%',
              marginLeft: -600,
              top: 0,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TakeCare;
